import { useQueryClient } from "@tanstack/react-query";
import CloseIcon from "../../assets/svg/CloseIcon";
import CustomText from "../atomic/CustomText";
import { useContext, useEffect } from "react";
import { ApplicationState } from "../../services/context/ApplicationStateContext";
import { twMerge } from "tailwind-merge";

function FilterPillbox({
  onClick,
  heading,
  value,
}: Readonly<{
  onClick: any;
  heading: string;
  value: string;
}>): JSX.Element {
  return (
    <div className="flex md:gap-4 gap-2 justify-between items-center text-royalBlue bg-sideNavGray p-1.5 mr-2 rounded-[26px] border border-[#BFC7CE] md:w-auto w-full">
      <div className="flex items-center md:gap-4 gap-2">
        <CustomText
          text={heading}
          fontWeight="font-semibold"
          className=""
          fontSize="md:text-sm text-xs"
        />
        <CustomText
          text={value}
          fontWeight="font-normal"
          className=""
          fontSize="md:text-sm text-xs"
        />
      </div>
      <button type="button" onClick={onClick} className="justify-end">
        <CloseIcon />
      </button>
    </div>
  );
}

function ContextFilters({
  hidePhysicianFilter,
  containerClassName,
}: Readonly<{
  hidePhysicianFilter?: boolean;
  containerClassName?: string;
}>): JSX.Element {
  const queryClient = useQueryClient();
  const {
    state: { selectedOrganization, selectedPhysician, selectedPathLab },
    dispatch,
  } = useContext(ApplicationState);
  const orgs: any = queryClient.getQueryData(["organizations"]);
  const clinicians: any = queryClient.getQueryData([
    "physiciansList",
    selectedOrganization,
  ]);
  const pathlabs: any = queryClient.getQueryData(["pathLabs"]);
  const orgName = orgs?.data?.find(
    (org: any) => org.id === selectedOrganization
  )?.name;
  const pathLabName = pathlabs?.data?.find(
    (org: any) => org.id === selectedPathLab
  )?.name;
  const foundClinician = clinicians?.data?.find(
    (clin: any) => clin.id === selectedPhysician
  );
  const clinicianName =
    foundClinician?.firstName + " " + foundClinician?.lastName;
  const roles: string[] =
    queryClient.getQueryData<any>(["profile"])?.user?.roles ?? [];
  const isPLUPhysician =
    roles.includes("Physician") && roles.includes("PathLab User");
  const isPhysicianOnly =
    (roles.length === 1 && roles.includes("Physician")) || isPLUPhysician;

  useEffect(() => {}, [
    selectedOrganization,
    selectedPathLab,
    selectedPhysician,
  ]);

  return (
    <div
      className={twMerge(
        `flex xs:flex-col md:flex-row xs:gap-y-4  md:items-center my-2`,
        containerClassName
      )}
    >
      {selectedOrganization && !!orgName && (
        <FilterPillbox
          heading="Organization:"
          value={orgName}
          onClick={() => {
            dispatch({ type: "SET_ORGANIZATION", payload: null });
            dispatch({ type: "SET_ORGANIZATION_DATA", payload: null });
            if (!isPhysicianOnly) {
              dispatch({ type: "SET_PHYSICIAN", payload: null });
              dispatch({ type: "SET_PHYSICIAN_DATA", payload: null });
            }
          }}
        />
      )}
      {selectedPhysician &&
        !!clinicianName &&
        !!hidePhysicianFilter === false &&
        !isPhysicianOnly && (
          <FilterPillbox
            heading="Clinician:"
            value={clinicianName}
            onClick={() => {
              dispatch({ type: "SET_PHYSICIAN", payload: null });
              dispatch({ type: "SET_PHYSICIAN_DATA", payload: null });
            }}
          />
        )}
      {selectedPathLab && !!pathLabName && (
        <FilterPillbox
          heading="Path lab:"
          value={pathLabName}
          onClick={() => {
            dispatch({ type: "SET_PATHLAB", payload: null });
          }}
        />
      )}
    </div>
  );
}

export default ContextFilters;
